var map = {
	"./collections.de-CH.json": 1651,
	"./collections.de-DE.json": 1652,
	"./collections.en-CA.json": 1653,
	"./collections.en-GB.json": 1654,
	"./collections.en-IN.json": 1655,
	"./collections.en-ME.json": 1656,
	"./collections.en-US.json": 1657,
	"./collections.es-EM.json": 1658,
	"./collections.es-ES.json": 1659,
	"./collections.fr-BE.json": 1660,
	"./collections.fr-CA.json": 1661,
	"./collections.fr-CH.json": 1662,
	"./collections.nl-BE.json": 1663,
	"./collections.nl-NL.json": 1664,
	"./collections.pl-PL.json": 1665,
	"./collections.pt-BR.json": 1666
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1650;